import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "variants",
  "aria-label": "Seleziona una variante"
}
const _hoisted_3 = { class: "list-itemn" }
const _hoisted_4 = { class: "radiobutton" }
const _hoisted_5 = ["id", "value", "disabled", "onClick"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "variants-desc" }
const _hoisted_8 = {
  key: 0,
  class: "name"
}
const _hoisted_9 = { class: "editor" }
const _hoisted_10 = {
  "data-mrgt": "20",
  class: "wdg wdg-table mrg"
}
const _hoisted_11 = {
  key: 0,
  class: "table",
  border: "1",
  cellpadding: "1",
  cellspacing: "1"
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  class: "row-column-02",
  "data-value": "tue",
  "data-start": "true"
}
const _hoisted_15 = { class: "unit" }
const _hoisted_16 = { class: "val" }
const _hoisted_17 = {
  class: "row-column-02",
  "data-value": "tue"
}
const _hoisted_18 = { class: "unit" }
const _hoisted_19 = { class: "val" }
const _hoisted_20 = {
  class: "row-column-02",
  "data-value": "tue"
}
const _hoisted_21 = { class: "unit" }
const _hoisted_22 = { class: "val" }
const _hoisted_23 = {
  key: 1,
  class: "disclaimer"
}
const _hoisted_24 = { class: "qty" }
const _hoisted_25 = {
  key: 0,
  class: "component"
}
const _hoisted_26 = { class: "input" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = { class: "nav" }
const _hoisted_29 = {
  key: 1,
  class: "note"
}
const _hoisted_30 = {
  class: "action mrg",
  "data-mrgt": "20"
}
const _hoisted_31 = { class: "button fastic-cart" }
const _hoisted_32 = {
  key: 1,
  class: "calltoaction",
  "data-size": "big"
}
const _hoisted_33 = { class: "button fastic-cart" }
const _hoisted_34 = ["href"]
const _hoisted_35 = { class: "label" }
const _hoisted_36 = {
  class: "alert mrg",
  "data-mrgt": "20"
}
const _hoisted_37 = {
  class: "delivery mrg",
  "data-mrgt": "20"
}
const _hoisted_38 = { class: "unit" }
const _hoisted_39 = { class: "delivery-note mrg" }

import { ref, computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductDetailAdd',
  props: {
    productCode: {},
    freeShippingTotal: {},
    language: {}
  },
  setup(__props: any) {

const store = useStore();

const props = __props;

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(true);
const isLoadingForm = ref(false);
const validationErrors = ref<any[]>([]);
const variantCode = ref<string>(null);
const quantity = ref<number>(0);

const product = computed(() => {
    let productData = store.getters["catalogueStore/product"];
    quantity.value = productData ? productData.bundleSize : 1;
    return productData;
});

const variant = computed(() => {
    return store.getters["catalogueStore/variant"];
});

onBeforeMount(async () => {
    await getProductInfo();

    setAnalytics();
});

async function getProductInfo() {
    const response = (await Axios.post(routes.Catalogue_GetProductInfo, { code: props.productCode })).data;

    store.commit("catalogueStore/setProduct", response);

    setVariant(response.variants[0]);

    isLoading.value = false;
}

function formatPrice(data: string) {
    return Number(data).toFixed(2).replace(".", ",");
}

function setVariant(data: any) {
    store.commit("catalogueStore/setVariant", data);

    variantCode.value = data.code;
}

function addQuantity() {
    quantity.value = Number(quantity.value);

    if (quantity.value) {
        quantity.value += product.value.bundleSize;
    } else {
        quantity.value = product.value.bundleSize;
    }
    if (quantity.value > 1000) {
        quantity.value = 1000;
    }
}

function removeQuantity() {
    quantity.value = Number(quantity.value);

    if (quantity.value) {
        quantity.value -= product.value.bundleSize;
    } else {
        quantity.value = product.value.bundleSize;
    }
    if (quantity.value < product.value.bundleSize) {
        quantity.value = product.value.bundleSize;
    }
}

function openMoreInfo() {
    GTagHelper.sendEvent("click", "info_request_more_info", "open");
}

function setAnalytics() {
    GTagHelper.sendCustomEvent("view_item", {
        currency: "EUR",
        value: product.value.variants[0].priceStep1,
        items: [
            {
                item_id: product.value.code,
                item_name: product.value.title,
                affiliation: "Technical Ceramic",
                currency: "EUR",
                item_category: product.value.categoryName,
                price: product.value.variants[0].priceStep1,
                discount: 0
            }
        ]
    });
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoadingForm.value = true;

    try {
        const response = (await Axios.post(routes.Cart_AddProduct, { productCode: product.value.code, variantCode: variant.value.code, quantity: quantity.value })).data;

        store.commit("cartStore/setCart", response.cartInfo);

        window.scrollTo({ top: 0, behavior: "smooth" });

        store.commit("cartStore/setIsCartPreviewVisible", true);

        setTimeout(function () {
            store.commit("cartStore/setIsCartPreviewVisible", false);
        }, 3000);

        var price = 0;

        if (quantity.value <= 25) {
            price = variant.value.priceStep1;
        } else if (quantity.value <= 100) {
            price = variant.value.priceStep2;
        } else {
            price = variant.value.priceStep3;
        }

        GTagHelper.sendCustomEvent("add_to_cart", {
            currency: "EUR",
            value: price * quantity.value,
            items: [
                {
                    item_id: product.value.code,
                    item_name: product.value.title,
                    affiliation: "Technical Ceramic",
                    currency: "EUR",
                    item_category: product.value.categoryName,
                    price: price,
                    discount: 0,
                    quantity: quantity.value
                }
            ]
        });
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoadingForm.value = false;
}

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (product.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.variants, (variant) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "variantCode",
                      id: variant.code,
                      value: variant.code,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((variantCode).value = $event)),
                      disabled: isLoadingForm.value,
                      onClick: ($event: any) => (setVariant(variant))
                    }, null, 8, _hoisted_5), [
                      [_vModelRadio, variantCode.value]
                    ]),
                    _createElementVNode("label", {
                      for: variant.code
                    }, _toDisplayString(variant.title), 9, _hoisted_6)
                  ]))
                }), 256))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (variant.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(variant.value.description), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (variant.value)
                ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
                    _createElementVNode("thead", null, [
                      (product.value.priceStepOption == '1')
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                            _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.UpTo25Units")), 1),
                            _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.UpTo100Units")), 1),
                            _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.Over100Units")), 1)
                          ]))
                        : (product.value.priceStepOption == '2')
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                              _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.UpTo3Units")), 1),
                              _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.UpTo10Units")), 1),
                              _createElementVNode("th", null, _toDisplayString(_unref(localizer).get("Catalogue.Common.Over10Units")), 1)
                            ]))
                          : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                          _createElementVNode("span", _hoisted_16, _toDisplayString(formatPrice(variant.value.priceStep1)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(formatPrice(variant.value.priceStep2)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(formatPrice(variant.value.priceStep3)), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (__props.language === 'it')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(localizer).get("Catalogue.Common.PriceTaxDisclimer")), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          (product.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    name: "BundleSize",
                    type: "number",
                    class: "textbox",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((quantity).value = $event)),
                    disabled: isLoadingForm.value
                  }, null, 8, _hoisted_27), [
                    [_vModelText, quantity.value]
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      class: "button fastic-angle-up",
                      "data-type": "add",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (addQuantity()))
                    }),
                    _createElementVNode("button", {
                      class: "button fastic-angle-down",
                      "data-type": "remove",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (removeQuantity()))
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (product.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_unref(localizer).get("Catalogue.Common.PiecesInThePackage")) + ": " + _toDisplayString(product.value.quantity), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", null, [
            (!isLoadingForm.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "calltoaction",
                  "data-size": "big",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm()))
                }, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(localizer).get("Catalogue.Common.AddToCart")), 1)
                ]))
              : (_openBlock(), _createElementBlock("button", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(localizer).get("Catalogue.Common.AddToCart")), 1)
                ])),
            _createElementVNode("a", {
              href: _unref(routes).Support_InfoRequest + '?inforequest=moreinfo',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (openMoreInfo())),
              "data-fancybox": "",
              "data-type": "iframe",
              class: "link"
            }, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "icon fastic-info" }, null, -1)),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(localizer).get("Catalogue.Common.WantMoreInformation")), 1)
            ], 8, _hoisted_34)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(validationError.message), 1))
        }), 256)),
        _createElementVNode("div", _hoisted_37, [
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "icon fastic-van" }, null, -1)),
          _createTextVNode(_toDisplayString(_unref(localizer).get("Catalogue.Common.FreeShippgingDisclimer")) + " ", 1),
          _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(localizer).get("Catalogue.Common.Euro")), 1),
          _createTextVNode(" " + _toDisplayString(__props.freeShippingTotal), 1)
        ]),
        _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(localizer).get("Catalogue.Common.FreeShippgingDisclimerNote")), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})